import React from 'react';
import styles from "./style.module.scss"
import {numberToFinanceFormat} from "../../../../utils";
import { t } from "i18next";

const ProfileCompanyCount = ({ totalCount, totalSum} ) => {
    const averagePrice = totalSum / totalCount;
    const averagePriceDisplay = isNaN(averagePrice) ? 0 : averagePrice;
    return (
        <div className={styles['profile__company-count']}>
            <div className={styles['profile__order']}>
                <div className={styles['profile__order-title']}>{t('ordersCount.completedOrders')}</div>
                <div className={styles['profile__order-subtitle']}>{totalCount}</div>
            </div>
            <div className={styles['profile__order']}>
                <div className={styles['profile__order-title']}>{t('ordersCount.totalPayments')}</div>
                <div className={styles['profile__order-subtitle']}>{numberToFinanceFormat(totalSum)} ₸ </div>
            </div>
            <div className={styles['profile__order']}>
                <div className={styles['profile__order-title']}>{t('ordersCount.averagePrice')}</div>
                <div className={styles['profile__order-subtitle']}>{numberToFinanceFormat(averagePriceDisplay)} ₸  </div>
            </div>
        </div>
    );
};

export default ProfileCompanyCount;